import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "cdnsa-account-waterfall",
  module: widgetModule,
  catalog: {
    description:
      "Daily distinct CDN/SA accounts detected, with newly observed and no-longer-observed counts compared with the preceding UTC day.",
    domain: "cdnsa",
    visual: "Waterfall chart",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  settings,
  defaultLayoutClassName: "col-span-12",
};
